import React, { lazy } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ContactForm } from '../components/ContactForm';
import { ContactInfo } from '../components/ContactInfo';
import { motion } from 'framer-motion';
import { MessageCircle, Sparkles, MapPin, Instagram, Facebook, Twitter, Youtube } from 'lucide-react';
export function Contact() {
  const socialLinks = [{
    icon: Instagram,
    href: '#',
    label: 'Instagram'
  }, {
    icon: Facebook,
    href: '#',
    label: 'Facebook'
  }, {
    icon: Twitter,
    href: '#',
    label: 'Twitter'
  }, {
    icon: Youtube,
    href: '#',
    label: 'YouTube'
  }];
  return <div className="min-h-screen bg-[#0B1014] text-white flex flex-col" data-id="element-1109">
      <Header data-id="element-1110" />

      {/* Hero Section */}
      <div className="relative pt-32 pb-16 overflow-hidden" data-id="element-1111">
        <div className="absolute inset-0 bg-gradient-to-b from-[#DDA247]/5 via-transparent to-transparent" data-id="element-1112" />
        <div className="absolute top-20 right-1/4 w-96 h-96 bg-[#DDA247]/10 rounded-full blur-[120px]" data-id="element-1113" />

        <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-1114">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-3xl mx-auto text-center" data-id="element-1115">
            <div className="flex items-center justify-center gap-3 mb-6" data-id="element-1116">
              <Sparkles className="w-6 h-6 text-[#DDA247]" data-id="element-1117" />
              <span className="text-sm text-[#DDA247] uppercase tracking-[0.2em] font-medium" data-id="element-1118">
                Get In Touch
              </span>
              <Sparkles className="w-6 h-6 text-[#DDA247]" data-id="element-1119" />
            </div>
            <h1 className="text-4xl md:text-6xl font-bold text-white uppercase tracking-tight mb-6 leading-tight" data-id="element-1120">
              Contact Us
            </h1>
            <p className="text-gray-400 text-base md:text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-1121">
              Have questions about reservations, events, or our services? We're
              here to help make your experience unforgettable.
            </p>
          </motion.div>
        </div>
      </div>

      {/* Main Content */}
      <main className="flex-1 pb-20 px-4 md:px-6 container mx-auto" data-id="element-1122">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-12" data-id="element-1123">
          {/* Contact Form - Takes up 3 columns */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.2,
          duration: 0.6
        }} className="lg:col-span-3" data-id="element-1124">
            <div className="bg-gradient-to-br from-[#0F161B] to-[#0B1014] border border-white/10 rounded-3xl p-8 md:p-10 shadow-2xl" data-id="element-1125">
              <div className="flex items-center gap-3 mb-8" data-id="element-1126">
                <div className="w-12 h-12 bg-[#DDA247]/10 rounded-xl flex items-center justify-center" data-id="element-1127">
                  <MessageCircle className="w-6 h-6 text-[#DDA247]" data-id="element-1128" />
                </div>
                <div data-id="element-1129">
                  <h2 className="text-2xl font-bold text-white uppercase tracking-wide" data-id="element-1130">
                    Send Us a Message
                  </h2>
                  <p className="text-sm text-gray-500" data-id="element-1131">
                    Fill out the form below and we'll respond shortly
                  </p>
                </div>
              </div>

              <ContactForm data-id="element-1132" />
            </div>

            {/* Moved from ContactInfo to balance layout */}
            <div className="flex flex-col gap-8 mt-8" data-id="element-1133">
              {/* Map Placeholder */}
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.4
            }} className="relative min-h-[300px] w-full bg-[#1A2228] border border-white/10 rounded-3xl overflow-hidden shadow-xl" data-id="element-1134">
                <iframe src="https://maps.google.com/maps?q=13460%20Baltimore%20Ave,%20Laurel,%20MD%2020707&t=&z=15&ie=UTF8&iwloc=&output=embed" width="100%" height="100%" style={{
                border: 0,
                minHeight: '300px'
              }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="House of Flavors Location" className="absolute inset-0 w-full h-full grayscale contrast-125 opacity-80 hover:grayscale-0 hover:opacity-100 transition-all duration-500" data-id="element-1135"></iframe>
              </motion.div>

              {/* Social Media */}
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.5
            }} className="bg-gradient-to-br from-[#1A2228] to-[#0F161B] border border-white/10 rounded-3xl p-8 shadow-xl flex flex-col justify-center w-full" data-id="element-1136">
                <h3 className="text-sm font-bold text-gray-400 uppercase tracking-widest mb-6 text-center" data-id="element-1137">
                  Follow Us
                </h3>
                <div className="flex justify-center gap-4" data-id="element-1138">
                  {socialLinks.map(social => <motion.a key={social.label} href={social.href} whileHover={{
                  scale: 1.1,
                  y: -2
                }} whileTap={{
                  scale: 0.95
                }} className="w-14 h-14 bg-[#DDA247]/10 rounded-xl flex items-center justify-center hover:bg-[#DDA247] hover:text-[#0B1014] text-[#DDA247] transition-all" aria-label={social.label} data-id="element-1139">
                      <social.icon className="w-6 h-6" data-id="element-1140" />
                    </motion.a>)}
                </div>
              </motion.div>
            </div>
          </motion.div>

          {/* Contact Info - Takes up 2 columns */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.3,
          duration: 0.6
        }} className="lg:col-span-2 space-y-8" data-id="element-1141">
            {/* SMS CTA */}
            <div className="bg-gradient-to-br from-[#DDA247] to-[#B8860B] rounded-3xl p-8 text-[#0B1014] shadow-xl" data-id="element-1142">
              <h3 className="text-2xl font-black uppercase tracking-tight mb-2" data-id="element-1143">
                Text to Book
              </h3>
              <p className="font-medium mb-6 opacity-90" data-id="element-1144">
                The fastest way to secure your VIP table or birthday booking.
              </p>
              <a href="sms:3014549401" className="text-3xl md:text-4xl font-black tracking-tighter hover:scale-105 transition-transform block" data-id="element-1145">
                301.454.9401
              </a>
              <div className="mt-4 text-xs font-bold uppercase tracking-widest opacity-80" data-id="element-1146">
                VIP • Birthdays • Bottle Service
              </div>
            </div>

            <ContactInfo data-id="element-1147" />
          </motion.div>
        </div>

        {/* FAQ Teaser */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.5
      }} className="mt-16 bg-gradient-to-r from-[#DDA247]/10 via-[#DDA247]/5 to-transparent border border-[#DDA247]/20 rounded-2xl p-8 text-center" data-id="element-1148">
          <h3 className="text-xl font-bold text-white mb-3 uppercase tracking-wide" data-id="element-1149">
            Looking for Quick Answers?
          </h3>
          <p className="text-gray-400 mb-6 max-w-2xl mx-auto" data-id="element-1150">
            Check out our frequently asked questions for instant information
            about reservations, dress code, parking, and more.
          </p>
          <motion.button whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="px-8 py-3 bg-[#DDA247] text-[#0B1014] font-bold rounded-xl uppercase tracking-wider hover:bg-white transition-colors" data-id="element-1151">
            View FAQ
          </motion.button>
        </motion.div>
      </main>

      <Footer data-id="element-1152" />
    </div>;
}